import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Input } from '../../ui/input.js';
import { useDevice } from '../../../contexts/DeviceContext.js';
import { cn } from '../../../lib/utils.js';

const FieldRoundIcon = forwardRef(
  ({
    id,
    value,
    placeholder = "",
    readOnly = false,
    disabled = false,
    rightIcon,
    onChange,
    error = false,
    ariaLabel,
    className,
    type = "text",
    ...props
  }, ref) => {
    const { isDesktop } = useDevice();
    const isButton = type === "button";
    const isEmpty = !value;
    const showAsPlaceholder = isButton && isEmpty;
    return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          type,
          id,
          ref,
          value: isButton ? value ?? placeholder ?? "" : value,
          onChange,
          placeholder: isButton ? void 0 : placeholder,
          readOnly,
          disabled,
          "aria-label": ariaLabel,
          ...props,
          className: cn(
            isDesktop ? "h-[66px]" : "h-14",
            "border rounded-lg w-full border-basic-04 px-4 pt-[17px] pb-[15px] placeholder:text-basic-04",
            "focus:border-interactive-primary-default-01 focus-visible:shadow-[inset_0_0_0_1px_var(--color-border-interactive-primary-default-01)]",
            rightIcon && "pr-12",
            readOnly && "border-state-disabled-03 text-basic-02",
            disabled && "border-state-disabled-03 text-basic-02",
            error ? "!border-interactive-danger !shadow-[inset_0_0_0_1px_var(--color-border-interactive-danger)]" : "",
            type === "button" && "text-left",
            showAsPlaceholder ? "text-basic-04" : "text-basic-02",
            className
          )
        }
      ),
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "absolute top-1/2 right-3 -translate-y-1/2",
          role: "button",
          tabIndex: 0,
          children: rightIcon
        }
      )
    ] });
  }
);

export { FieldRoundIcon };
